<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      spinner="bar-fade-scale"
      color="#1976d2"
      size="128"
      is-full-screen
    />
    <v-snackbar v-model="showSnackbar" color="black" right>
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>

    <v-layout wrap justify-center>
      <v-flex px-0 pt-5 xs12 sm12 md12 lg12 xl12 text-center>
        <v-card flat min-height="100vh">
          <v-card-title class="elevation-1">
            Brand
            <v-spacer></v-spacer>
            <v-flex md2>
              <v-dialog
                :retain-focus="false"
                v-model="dialog"
                persistent
                max-width="800px"
                :key="dialog"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    outlined
                    color="green"
                    width="100%"
                    v-bind="attrs"
                    v-on="on"
                  >
                    Add
                  </v-btn>
                </template>
                <v-card>
                  <v-form v-model="addslider" ref="addcat">
                    <v-card-title>
                      <span class="headline">Add Category</span>
                    </v-card-title>
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="12" md="12">
                            <v-text-field dense label="brand" v-model="brand">
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" sm="12" md="12">
                            <v-text-field
                              dense
                              label="Listing Order"
                              v-model="listingOrder"
                            >
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" sm="12" md="12">
                            <v-text-field
                              dense
                              label="Description"
                              v-model="description"
                            >
                            </v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="12" md="12">
                            <ImageComp
                              @stepper="winStepper"
                              :height="'10'"
                              :width="'10'"
                              :heading="'brand Image'"
                              :componentType="'offerImage'"
                            />
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="dialogclose()">
                        Close
                      </v-btn>
                      <v-btn
                        color="blue darken-1"
                        text
                        :disabled="!addslider"
                        @click="add()"
                      >
                        Save
                      </v-btn>
                    </v-card-actions>
                  </v-form>
                </v-card>
              </v-dialog>
            </v-flex>
          </v-card-title>
          <div v-if="CategoryList.length > 0">
            <v-layout wrap justify-start v-if="CategoryList.length > 0">
              <v-flex v-for="(item, i) in CategoryList" :key="i" md6 pa-4>
             
                  <v-card style="line-height: 16px">
                    <v-layout wrap>
                      <v-flex md3 pl-2>
                        <img
                          v-if="item.icon"
                          v-viewer
                          style="
                            width: 100%;
                            object-fit: contain;
                            cursor: pointer;
                          "
                          :src="baseURL + '/file/get/' + item.icon"
                          height="100px"
                        />

                        <v-img
                          v-else
                          style="
                            width: 100%;
                            object-fit: contain;
                            cursor: pointer;
                          "
                          src="../../assets/images/no-image.png"
                          height="100px"
                          contain
                        >
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height ma-0"
                              align="center"
                              justify="center"
                            >
                              <v-progress-circular
                                indeterminate
                                color="#FF2323"
                              ></v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </v-flex>
                      <v-flex md9>
                        <v-layout wrap justify-center fill-height px-2>
                          <v-flex text-center align-self-center xs12 pt-4>
                               <router-link :to="'/Gocerysubcategory?id=' + item._id">
                            <span
                              style="
                                font-size: 18px;
                                color: #000000;
                                font-weight: bold;
                              "
                            >
                              {{ item.brandName }}
                            </span>
                               </router-link>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex
                        xs12
                        text-left
                        pl-2
                        pb-2
                        pt-3
                        style="font-size: 12px; color: #000000"
                      >
                        <span>Description :</span>&nbsp;<span>{{
                          item.description
                        }}</span>
                      </v-flex>
                      <v-flex xs12>
                        <v-layout wrap pb-3>
                          <v-flex xl6 lg6 md6 sm6 xs6 px-5 justify-center>
                            <v-dialog v-model="item.delete" max-width="600px">
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  small
                                  class="mr-2"
                                  outlined
                                  block
                                  v-on="on"
                                  v-bind="attrs"
                                  color="red"
                                >
                                  Delete
                                </v-btn>
                              </template>
                              <v-card>
                                <v-card-title
                                  >Are you sure you want to delete this
                                  brand?</v-card-title
                                >
                                <v-card-actions>
                                  <v-spacer></v-spacer>
                                  <v-btn
                                    color="blue darken-1"
                                    text
                                    @click="item.delete = false"
                                    >Cancel</v-btn
                                  >
                                  <v-btn
                                    color="blue darken-1"
                                    text
                                    @click="deleteItem(item)"
                                    >OK</v-btn
                                  >
                                  <v-spacer></v-spacer>
                                </v-card-actions>
                              </v-card>
                            </v-dialog>
                          </v-flex>
                          <v-flex xl6 lg6 md6 sm6 xs6 px-5 justify-center>
                            <v-btn
                              small
                              class="mr-2"
                              outlined
                              block
                              color="green"
                              @click="editSlider(item)"
                            >
                              Edit
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-card>
               
              </v-flex>
            </v-layout>
          </div>
          <div v-else>
            <v-layout pt-15 justify-center fill-height wrap>
              <v-flex text-center xs12 lg12>
                <span style="font-size: 22px; letter-spacing: 1px">
                  No Data Found...
                </span>
              </v-flex>
            </v-layout>
          </div>
          <v-dialog v-model="editdialog" max-width="800px">
            <v-card>
              <v-card-title>
                <span class="headline">Edit offer</span>
              </v-card-title>
              <v-card-text>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-text-field
                      dense
                      label="brand"
                      v-model="editingitem.brandName"
                    >
                    </v-text-field>
                  </v-flex>
                  
                  <v-flex xs12 pt-3>
                    <v-text-field
                      dense
                      label="Listing Order"
                      v-model="editingitem.listingOrder"
                    >
                    </v-text-field>
                  </v-flex>
                   <v-col cols="12" sm="12" md="12">
                            <v-text-field
                              dense
                              label="Description"
                              v-model="editingitem.description"
                            >
                            </v-text-field>
                          </v-col>
                </v-layout>
                <v-layout wrap>
                  <v-flex xs12 md12 lg12>
                    <ImageComp
                      :singleImage="editingitem.icon"
                      :pageId="editingitem._id"
                      @stepper="winStepper"
                      :height="10"
                      :width="10"
                      :heading="'Upload Image'"
                      :componentType="'offerImage'"
                    />
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="editdialog = false">
                  Close
                </v-btn>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="edit(editingitem._id)"
                >
                  Save
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-card>
        <div class="text-center pb-5">
          <v-pagination
            :length="pages"
            :total-visible="8"
            v-model="currentPage"
            color="#FDAC53"
          ></v-pagination>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
import ImageComp from "@/components/Common/singleImage";
// import { VueEditor } from "vue2-editor";
export default {
  components: {
    // VueEditor,
    ImageComp,
  },
  data() {
    return {
      description: null,
      brand: null,
      listingOrder: null,
      ServerError: false,
      widthOfCard: "250px",
      rot: 0,
      formDataCover: new FormData(),
      offerImage: null,
      showSnackbar: false,
      msg: null,
      pages: 0,
      appLoading: false,
      currentPage: 1,
      totalData: 0,
      totalRows: 0,
      delete: false,
      dialogDelete: false,
      dialog: false,
      dialog1: false,
      editdialog: false,
      editingitem: [],
      CategoryList: [],
      data: [],
      addslider: false,
      imgId: "",
      rules: {
        required: (value) => !!value || "Required.",
        counter: (value) => value.length <= 20 || "Max 20 characters",
        num: (value) => (value < 100 && value >= 0) || "Must be between 0-100",
      },
      Rules: [(value) => !!value || "Required."],
      titleRule: [(v) => v.length < 50 || "Min 50 characters"],
      sellers: [],
    };
  },

  mounted() {
    this.getData();
    this.getSellers();
  },
  // watch: {
  //   rot() {
  //     if (this.rot > 360) this.rot = 0;
  //   },
  // },
  methods: {
    getProduct(sellerId) {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/admin/seller/product/list",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          userid: sellerId,
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.products = response.data.data;
            this.totalCount = response.data.totalLength;
            // this.pages = response.data.pages;
            this.appLoading = false;
          } else {
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    winStepper(window_data) {
      if (window_data.type == "offerImage") {
        this.offerImage = window_data.selectedFiles;
      }
      if (window_data.type == "offerCoverImage") {
        this.offerCoverImage = window_data.selectedFiles;
      }
    },
    getData() {
      this.appLoading = true;
      axios({
        url: "/grocery/brand/get/list",
        method: "get",
        headers: {
          token: localStorage.getItem("token"),
        },

        // params: {
        //   count: this.count,
        //   page: this.currentPage,
        //   offerType: "product",
        // },
      })
        .then((response) => {
          this.appLoading = false;

          this.CategoryList = response.data.data;

          this.pages = response.data.totalPages;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    getSellers() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/sellers/list",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            {
              this.sellers = response.data.data;
              this.appLoading = false;
            }
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    add() {
      this.appLoading = true;
      axios({
        url: "/grocery/brand/add",
        method: "POST",
        data: {
          name: this.brand,
          listingOrder: this.listingOrder,
          description: this.description,
        },
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.imgId = response.data.id;
            if (this.offerImage) this.uploadImage(response.data.id);
            this.getData();
            this.msg = "Added Sucessfully";
            this.showSnackbar = true;
            // Object.keys(this.offerData).forEach(
            //   (key) => (this.offerData[key] = null)
            // );
            this.link = null;
            this.title = null;
            this.caption = null;
            this.date = null;
            this.imagePreview = null;
            this.file = null;
            this.dialog = false;
          } else {
            this.msg = response.data.msg;
            this.showSnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    edit() {
      this.appLoading = true;
      this.formDataCover.append("listingOrder", this.editingitem.listingOrder);
      this.formDataCover.append("name", this.editingitem.brandName);
      this.formDataCover.append("description", this.editingitem.description);
      this.formDataCover.append("id", this.editingitem._id);
      axios({
        method: "POST",
        url: "/grocery/brand/edit",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          listingOrder: this.editingitem.listingOrder,
          name: this.editingitem.name,
          id: this.editingitem._id,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            if (this.offerImage) this.uploadImage(response.data.id);
            this.editdialog = false;
            this.formDataCover = new FormData();
            this.msg = response.data.msg;
            this.showSnackbar = true;
            this.getData();
          } else {
            this.msg = "Can't Update";
            this.showSnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    editSlider(item) {
      this.editingitem = item;
      if (this.editingitem.sellerId) {
        this.editingitem.seller = item.sellerId.uid;
        this.getProduct(item.sellerId.uid);
      }
      if (this.editingitem.productId)
        this.editingitem.product = item.productId._id;

      this.editdialog = true;
    },
    deleteItem(r) {
      this.appLoading = true;
      axios({
        url: "/grocery/category/delete/" + r._id,
        method: "POST",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.delete = false;
          this.appLoading = false;
          if (response.data.status) {
            this.msg = "Delete Sucessfully";
            this.showSnackbar = true;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showSnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    dialogclose() {
      this.link = null;
      this.dialog = false;
    },

    uploadImage(id) {
      let formData = new FormData();
      formData.append("id", id);
      formData.append("icon", this.offerImage);

      axios({
        method: "POST",
        url: "/grocery/Brand/upload/icon",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.getData();
            this.offerImage = null;

            this.showSnackbar = true;
            this.msg = "Uploaded Successfully";
            this.dialog = false;
          } else {
            this.msg = "Can't Update";
            this.showSnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    formatDate(item) {
      var dt = new Date(item);
      var year = dt.getFullYear();
      dt = dt.toString();
      var strTime = dt.slice(4, 10) + " " + year;
      return strTime;
    },
    formatTime(item) {
      if (!item) return;
      var hours = Number(item.split(":")[0]);
      var minutes = Number(item.split(":")[1]);
      var ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = hours + ":" + minutes + " " + ampm;
      return strTime;
    },
  },
};
</script>